import { useEffect, useState } from "react";
import { PenLine, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";
import { Btn } from "../kit/Kit";
import { FirmaPad } from "./FirmaPad";

// Panel del Firmante: guarda su firma una vez y autoriza (o revoca) su aplicación automática al VoBo de Ernesto Gómez.
export const MiFirma = () => {
  const [e, setE] = useState(null);
  const [png, setPng] = useState("");
  const [cambiar, setCambiar] = useState(false);
  const load = () => http.get("/altas/mi-firma/estado").then((r) => setE(r.data));
  useEffect(() => { load(); }, []);
  if (!e) return null;
  const guardar = () => http.post("/altas/mi-firma", { png }).then(() => { toast.success("Firma guardada"); setCambiar(false); setPng(""); load(); }).catch((x) => toast.error(errMsg(x)));
  const autorizar = (v) => http.post("/altas/mi-firma/autorizacion", { autoriza: v }).then(() => { toast.success(v ? "Autorización registrada" : "Autorización revocada"); load(); }).catch((x) => toast.error(errMsg(x)));
  return (
    <section className="mb-8 rounded-3xl border border-[#E2DDD5] bg-white p-5 sm:p-6" data-testid="mi-firma">
      <h2 className="flex items-center gap-2 font-serif-display text-2xl font-bold"><PenLine size={20} />Mi firma</h2>
      {(!e.registrada || cambiar) ? <div className="mt-4 max-w-lg space-y-3">
        <p className="text-sm text-[#5C5850]">Dibuja tu firma una sola vez; se usará en los convenios de referenciadores.</p>
        <FirmaPad onChange={setPng} testid="mi-firma-pad" />
        <Btn disabled={!png} onClick={guardar} data-testid="mi-firma-guardar">Guardar mi firma</Btn>
      </div> : <p className="mt-2 text-sm text-[#2F7D4F]" data-testid="mi-firma-registrada">Firma guardada. <button type="button" className="font-semibold underline" onClick={() => setCambiar(true)} data-testid="mi-firma-cambiar">Cambiarla</button></p>}
      {e.registrada && <label className="mt-5 flex max-w-2xl items-start gap-3 rounded-2xl bg-[#F2F0EC] p-4 text-sm">
        <input type="checkbox" className="mt-1" checked={e.autorizada} onChange={(x) => autorizar(x.target.checked)} data-testid="mi-firma-autoriza" />
        <span><b>{e.texto}</b>.{e.autorizada && <span className="mt-1 block text-xs text-[#5C5850]" data-testid="mi-firma-autorizada"><ShieldCheck size={12} className="mr-1 inline" />Autorizado el {(e.autorizacion?.at || "").slice(0, 16).replace("T", " ")} UTC. Desmarca para revocar.</span>}</span>
      </label>}
    </section>
  );
};
